module.exports = __webpack_public_path__ + "static/media/s3.d018043f.png";